import { Globals } from '@bai/utils/types';

export function addValueToGlobals<TName extends keyof Globals>(
  name: TName,
  value: Globals[TName],
) {
  if (!window.LEGACY_GLOBALS || window.LEGACY_GLOBALS == null)
    window.LEGACY_GLOBALS = {};
  window.LEGACY_GLOBALS[name] = value;
}
